// extracted by mini-css-extract-plugin
export default {"forest-green":"#013a4c","dark-green-04":"#d6dfe2","TimeToSign":"_TimeToSign--LA5pf","Divider":"_Divider--LLWs0","TimeToSignHeader":"_TimeToSignHeader--nfxyD"};